// extracted by mini-css-extract-plugin
export default {"passwordFormControl":"ibsrY","newPassInputs":"OQiXQ","passwordInput":"Az4iH","validationInfo":"hTpnj"};